module.exports = __webpack_public_path__ + "assets/img/dy.f2d83956.png";